const DEFAULT_ERROR = 'SOMETHING_WENT_WRONG';

export default class AxiosFormatResponseStrategy {
  fail(error) {
    const errorObj =
      error && ((error.response && (error.response.data || error.response)) || error);

    errorObj.message = errorObj.message || DEFAULT_ERROR;

    return Promise.reject(errorObj);
  }

  success(response) {
    return Promise.resolve(response && response.data);
  }
}
